import React from "react";
import SubPageLayout from "../components/SubPageLayout";
import Systems from "../components/home/Systems";
import FaqBlock from "../components/home/FaqBlock";
import FinalCta from "../components/home/FinalCta";

export default function ProductsPage() {
  return (
    <SubPageLayout testid="products-page" eyebrow="Our Systems" title="Water Treatment, Designed Around Your Home."
      subtitle="Whole-home filtration and softening for city and well water, plus reverse osmosis drinking water. Every recommendation starts with a water test."
      metaDescription="Whole-home water filtration, water softeners, well water treatment and reverse osmosis systems for Northern Virginia homes from Honest Water LLC.">
      <div className="pt-16 md:pt-24 bg-[#F4F1E9]"><Systems bare /></div>
      <FaqBlock />
      <FinalCta />
    </SubPageLayout>
  );
}
